import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { DeviceType } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './device-type-columns';
import { Fields } from './device-type-fields';
import { useValidationSchema } from './device-type-schema';

export function DeviceTypeEvidence() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();
  const columns = useColumns();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.DEVICE_TYPE_WRITE],
      EDIT: [Permission.DEVICE_TYPE_WRITE],
      REMOVE: [Permission.DEVICE_TYPE_WRITE],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<DeviceType>({
    version: 1,
    identifier: 'DEVICE_TYPE',
    apiProps: {
      url: EvidenceApiUrl.DEVICE_TYPE,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__DEVICE_TYPE__TABLE__TITLE',
        defaultMessage: 'Druh zariadenia',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__DEVICE_TYPE__DETAIL__TITLE',
          defaultMessage: 'Druh zariadenia',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: btnPermissions,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      initNewItem: () => ({ active: true } as DeviceType),
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
